import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'joinText',
    standalone: true
})
export class JoinTextPipe implements PipeTransform {
    transform(items: Array<any>, sep = ', '): string {
        if (items && Array.isArray(items)) {
            return items.filter((x) => x).join(sep);
        }

        return '';
    }
}
